import React, {FC} from "react"

import {Checkbox} from "@irati/ui/src/FormItem"
import Flex from "@irati/ui/src/Flex"
import {ValidationProps} from "@irati/utils/validation/Input"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Spacing from "@irati/ui/src/Spacing"
import {Row} from "@irati/ui/src/ColumnRow"
import {Body} from "@irati/ui/src/Typography"
import auth from "@irati/auth"

interface Props extends ValidationProps<string> {
  id?: string,
  value: boolean,
  availableBalance: number,
  remainingBalance: number,
  currency: string,
  onChange: (value: boolean) => void
}

const PayByWalletCheckBox: FC<Props> = (props: Props) => {
  const {value, onChange, currency, availableBalance = 0, remainingBalance} = props
  if (!auth.apps("wallet.users") || availableBalance <= 0) {
    return null
  }
  return (
    <Spacing marginBottom={2}>
      <Row>
        <Checkbox
          name="payByWalletCheckbox"
          id="platform.wallet.components.payByWallet.checkbox.label"
          checked={value}
          onChange={() => onChange(!value)}>
          <Flex inline alignItems="center" marginTop>
            <Body small>
              <FormattedMessage id="platform.wallet.components.payByWallet.checkbox.label" />
            </Body>
            <Icon icon={IconTypes.wallet} marginRight marginLeft />
            <FormattedCurrency currency={currency} value={availableBalance} />
          </Flex>
        </Checkbox>
      </Row>
      {value && (
        <Flex marginTop>
          <Body small>
            <FormattedMessage
              id="platform.wallet.components.payByWallet.remainingBalance"
              values={{amount: <FormattedCurrency value={remainingBalance} currency={currency} />}} />
          </Body>
        </Flex>
      )}
    </Spacing>
  )
}

export default PayByWalletCheckBox
